<template>
  <div>
    <div id="reservation">
      <div class="page-container" id="reservation-container">
        <div class="page-content" id="reservation-content">
          <header id="main-menu" class="logo-header">
            <div class="store-info menu-content">
              <div class="logo-col">
                <img :src="storeLogo" />
              </div>
              <div class="store-name">
                <h1>{{ storeName }}</h1>
              </div>
            </div>
          </header>
          <nav id="main-nav" class="detail-nav">
            <div class="reservation-tips-grid">
              <div class="tip-grid-col">
                <div>
                  <span class="icon-users"></span>
                  <input
                    type="hidden"
                    name="covers"
                    id="covers"
                    v-model="currentSize"
                  />
                  <div id="grid-number-col" class="tip-grid-col-bottom">
                    {{ currentSize }}
                  </div>
                </div>
              </div>
              <div class="tip-grid-col">
                <div>
                  <span class="icon-calendar-alt-fill"></span>
                  <input type="hidden" name="date" id="date" />
                  <div id="grid-date-col" class="tip-grid-col-bottom">
                    {{ currentDate }}
                  </div>
                </div>
              </div>
              <div class="tip-grid-col">
                <div>
                  <span class="icon-clock2"></span>
                  <div
                    id="grid-time-col"
                    class="tip-grid-col-bottom"
                    data-sort=""
                    data-tab="0"
                    data-time-tab="0"
                  >
                    {{ currentTime }}
                  </div>
                  <input type="hidden" name="time" id="time" />
                  <input type="hidden" name="table_id" id="table_id" />
                  <input type="hidden" name="session_id" id="session_id" />
                </div>
              </div>
            </div>
          </nav>
          <article class="swiper-container" id="swiper-container">
            <div class="swiper-wrapper">
              <section id="page-5" class="swiper-slide swiper-no-swiping">
                <div class="orderDetial-mod">
                  <div id="orderDetial-mod">
                    <ul class="order-details">
                      <li class="name-col">
                        <div class="col-label">Name:</div>
                        <strong id="orderName">
                          <span id="orderFirstName">{{
                            infoForm.firstName
                          }}</span
                          >&nbsp;<span id="orderLastName">{{
                            infoForm.surname
                          }}</span>
                        </strong>
                      </li>
                    </ul>
                    <ul class="order-details">
                      <li class="email-col">
                        <div class="col-label">Email:</div>
                        <strong id="orderEmail">{{ infoForm.email }}</strong>
                      </li>
                    </ul>
                    <ul class="order-details">
                      <li class="phone-col">
                        <div class="col-label">Phone:</div>
                        <strong id="orderPhone">
                          <span
                            v-show="
                              infoForm.areaCode !== '' ||
                              infoForm.areaCode !== ' '
                            "
                            >{{ infoForm.areaCode }}
                          </span>
                          {{ infoForm.phone }}
                        </strong>
                      </li>
                    </ul>
                    <ul
                      class="order-details flex"
                      id="depositCol"
                      v-show="depositPrice !== ''"
                    >
                      <li class="deposit-col flex3">
                        <div class="col-label">Deposit:</div>
                        <strong id="orderDeposit"
                          >&pound;{{ depositPrice }}</strong
                        >
                      </li>
                      <li class="people-col flex1">
                        <div class="col-label">People:</div>
                        <strong id="orderPeople">{{ currentSize }} px</strong>
                      </li>
                    </ul>
                    <ul class="order-details flex">
                      <li class="date-col flex2">
                        <div class="col-label">Date:</div>
                        <strong id="orderDate">{{ currentDate }}</strong>
                      </li>
                      <li class="week-col flex1">
                        <div class="col-label">On:</div>
                        <strong id="orderWeek">{{ week }}</strong>
                      </li>
                      <li class="time-col flex1">
                        <div class="col-label">Time:</div>
                        <strong id="orderTime">{{ currentTime }}</strong>
                      </li>
                    </ul>
                  </div>
                </div>
              </section>
            </div>
          </article>
          <div class="swiper-pagination">
            <div class="mb25">
              <button
                class="btn"
                style="width: 100%"
                @click="goAnotherReservation"
              >
                Make another reservation
              </button>
            </div>
            <div>
              <button
                style="width: 100%"
                type="button"
                class="btn cancel-btn"
                @click="addToCalendar"
              >
                Add to calendar
              </button>
              <!-- <a
                style="width: 100%"
                class="btn cancel-btn"
                :href="ics_url"
                target="_blank"
                id="getICSlik"
                >Add to calendar</a
              > -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <a-modal
      v-model="confirmedModalVisible"
      title=""
      :footer="null"
      id="confirmedModal"
      centered
    >
      <p class="modal-text">
        Your booking has been confirmed.<br />
        If you have not received your booking confirmation email please check
        your<br /><span class="">Spam Folder</span>.
      </p>

      <div class="modalFooterBtn-col">
        <button
          type="button"
          class="btn btn-primary"
          @click="hideConfirmedModal"
        >
          Okay
        </button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import Loading from "../components/loading.vue";
import { configTheme } from "@/utils/theme";
export default {
  name: "Success",
  components: {
    Loading,
  },

  data() {
    return {
      storeLogo:
        "https://pic.streetaway.cn/uploads/4b/29/d4/48/07/fc19e24c99a90ae85c61d8.png",
      storeName: "Spark Demo",
      storePhone: "10000",
      isHidden: true,
      paramsValid: true,
      currentPage: 0,
      week: "Wednesday",
      currentSize: "5",
      currentDate: "10 Jun 2020",
      currentTime: "08:30",
      infoForm: {
        firstName: "Eric",
        surname: "Guo",
        areaCode: "+44",
        phone: "12345678901",
        email: "BBBddd@AAa.org",
      },
      depositPrice: "44.00",
      read: true,
      selectedDate: "",
      store_id: 0,
      showCancelAlert: false,
      cancelConfirmed: false,
      res_id: 0,
      loadingShow: true,
      url_link: "/reservation/StreetAwayDemo",
      ics_url: "javascript:vpid(0)",
      confirmedModalVisible: true,
    };
  },
  computed: {
    isFrame() {
      return this.$route.query.is_frame == 1;
    },
  },
  created() {
    var reserve_number = this.$route.params.reserve_number;
    this.res_id = reserve_number;
    this.getReserveData(reserve_number);
  },

  methods: {
    getStoreData(store_name) {
      axios
        .get(process.env.API_URL + "htmlReserve/getStoreData", {
          params: { store_name },
        })
        .then((res) => {
          console.log(res);
          this.store_id = res.data.data.store_id;
          this.storeName = res.data.data.store_name;
          this.storePhone = res.data.data.contact_phone;
          this.url_link = "/reservation/" + this.storeName;
          this.storeLogo = res.data.data.logo;

          if (res.data.data.style_status == 1) {
            console.log(res.data.data.style_content);
            this.customTheme = res.data.data.style_content;
            const { brandColor, fontColor } = this.customTheme;
            configTheme(brandColor, fontColor);
          } else {
            configTheme("#f08a24", "#000000");
          }
        });
    },
    getReserveData(res_id) {
      axios
        .get(process.env.API_URL + "htmlReserve/getReserveData", {
          params: { reserve_id: res_id },
        })
        .then((res) => {
          if (res.data.data.status == 4) {
            this.cancelConfirmed = true;
            this.isHidden = false;
          }
          this.getStoreData(res.data.data.store_name);
          this.infoForm.firstName = res.data.data.cust_first_name;
          this.infoForm.surname = res.data.data.cust_surname;
          this.currentDate = res.data.data.date;
          this.week = res.data.data.wekday;
          this.currentTime = res.data.data.r_time;
          this.currentSize = res.data.data.covers;
          this.infoForm.phone = res.data.data.cust_phone;
          this.infoForm.areaCode = res.data.data.cust_areacode_p;
          this.infoForm.email = res.data.data.cust_email;
          if (res.data.data.slogo != 1) {
            this.storeLogo = res.data.data.slogo;
          }
          this.depositPrice = res.data.data.ned_pay;
          if (res.data.data.ics_url && res.data.data.ics_url != "") {
            this.ics_url = res.data.data.ics_url;
          }

          this.loadingShow = false;
        });
    },
    confirmReserve(res_id) {
      axios
        .post(process.env.API_URL + "htmlReserve/confirmReserve", {
          params: { res_id: res_id },
        })
        .then((res) => {
          this.isHidden = false;
        });
    },
    cancelConfirm(res_id) {
      axios
        .post(process.env.API_URL + "htmlReserve/cancelConfirm", {
          params: { res_id: res_id },
        })
        .then((res) => {
          this.cancelConfirmed = true;
        });
    },
    hideConfirmedModal() {
      this.confirmedModalVisible = false;
    },
    goAnotherReservation() {
      // location.href = this.url_link;
      open(this.url_link);
    },
    addToCalendar() {
      open(this.ics_url);
      // location.href = this.ics_url;
    },
  },
  mounted() {},
};
</script>
<style scoped="scoped">
#all-covers {
  border-color: var(--brandColor);
}

.select-col select {
  outline: none;
  -webkit-appearance: none;
  position: relative;
}

.select-col::after {
  position: absolute;
  content: "";
  display: block;
  width: 0;
  height: 0;
  right: 10px;
  top: 15px;
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-left: 0.3em solid transparent;
  border-color: #3d1cba transparent transparent transparent;
}

#reservation #selectPartySize-mod .radioButtonCol.grid_3 {
  grid-template-columns: repeat(3, 1fr);
}

.company-logo {
  width: 100px;
  height: 100px;
}
</style>
<style lang="scss" scoped>
.isFrame {
  #page-index,
  .page-content {
    overflow-y: unset !important;
  }
  &.isWideScreen {
    #page-index,
    .page-content {
      max-width: 65% !important;
    }
  }

  #main-menu,
  #main-nav,
  #main-title {
    width: 100%;
    position: relative !important;
    transform: unset !important;
    max-width: unset !important;
    top: unset !important;
    left: unset !important;
  }
  .swiper-container {
    overflow-y: auto !important;
    padding-top: 0 !important;
  }
}
.tip-grid-col {
  display: flex;
  align-items: center;
  justify-content: center;
}
#reservation nav.detail-nav {
  border-top: 0;
  border-bottom: 0;
}
#calendar-modal {
  margin-top: 20px;
}
.step-title {
  margin-bottom: 10px;
}
.tip-grid-col-bottom {
  height: 27px;
}

.isNarrowTop {
  #reservation {
    .logo-header {
      height: 74px;
    }
  }
}
.btn {
  color: #fff;
  border-radius: 6px;
}
.modal-text {
  color: #000;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/page/Success2.vue